import { useMutation } from '@tanstack/react-query';
import { apiClient } from 'api';
import { useToast } from 'hooks/useToast';

interface DecisionBucketPayload {
  decision: string;
  range_from: number;
  range_to: number;
}

export interface DecisionBucketUpdatePayload {
  assessment_id: string;
  decision_buckets: DecisionBucketPayload[];
}

/**
 * Hook to update decision buckets using React Query mutation
 */
export const useDecisionBucketUpdate = () => {
  const { openToast } = useToast();

  return useMutation({
    mutationFn: async ({ assessmentId, decisionBuckets }: { assessmentId: string; decisionBuckets: DecisionBucketPayload[] }) => {
      const response = await apiClient.post(
        '/assessment/decision-bucket/',
        {
          assessment_id: assessmentId,
          decision_buckets: decisionBuckets,
        }
      );
      return response.data;
    },
    onSuccess: () => {
      openToast({
        show: true,
        heading: 'Success',
        text: 'Decision buckets updated successfully',
        type: 'success',
        timeOut: 5000,
      });
    },
    onError: (err: any) => {
      const errorMessage = err?.response?.data?.message || 'Failed to update decision buckets';
      openToast({
        show: true,
        heading: 'Sorry',
        text: errorMessage,
        type: 'error',
        timeOut: 5000,
      });
    },
  });
};